const Builder = require('./BuilderBase');
const HiddenFor = require('./HiddenFor');
const ShortTextCriteria = require('./ShortTextCriteria');
const IntegerCriteria = require('./IntegerCriteria');
const DropDownCriteria = require('./DropDownCriteria');
const MultiPickerDropDownCriteria = require('./MultiPickerDropDownCriteria');

module.exports = class WorkflowCriteriaPane extends Builder {
    constructor() {
        super('workflowPane_WorkflowCriteriaPane', 'WorkflowCriteriaPane');
    }

    hiddenFor(role) {
        let hiddenFor = new HiddenFor(role);
        this.addChildBlock(hiddenFor, 'securityModifier');
        return this;
    }

    ShortTextCriteria(title, properties) {
        let child = new ShortTextCriteria(title, properties);
        this.addChildBlock(child);
        return child;
    }

    IntegerCriteria(title, properties) {
        let child = new IntegerCriteria(title, properties);
        this.addChildBlock(child);
        return child;
    }

    DropDownCriteria(title, properties) {
        let child = new DropDownCriteria(title, properties);
        this.addChildBlock(child);
        return child;
    }

    MultiPickerDropDownCriteria(title, properties) {
        let child = new MultiPickerDropDownCriteria(title, properties);
        this.addChildBlock(child);
        return child;
    }
};
